import { useTheme } from "styled-components";

import Typography from "@8x8/oxygen-typography";

const PageTitle = ({ children, className, forwardedRef }) => {
  const theme = useTheme();
  return (
    <Typography
      className={className}
      theme={theme}
      size={"lg"}
      weight={"attention"}
      forwardedRef={forwardedRef}
    >
      {children}
    </Typography>
  );
};

export default PageTitle;
